<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <el-page-header content="活动收集配置" @back="goBack" />
          <CommonExport :id="aid" :export-title="'系数导出'" :import-title="'系数导入'" style="float: right" :import-p="'config:rewardCollectEdit:import'" :export-p="'config:rewardCollectEdit:export'" :get-table="getTables" :import-method="importActivityStageCoefficientCfg" :export-method="exportStageCoefficientCfg" />
        </div>

        <el-form>
          <el-form-item label="进度条颜色" prop="colorType">
            <el-form :inline="true">
              <el-form-item>
                <el-select v-model.number="extraData.colorType" filterable placeholder="请选择">
                  <el-option v-for="item in colorType" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item label="ICON主题(收集物)" prop="icon">
                <el-select v-model="extraData.iconType" placeholder="请选择">
                  <el-option v-for="item in iconType" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item label="是否有spin动画" prop="isShowSpine">
                <el-select v-model.number="extraData.isShowSpine" placeholder="请选择">
                  <el-option v-for="item in openPushType" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item label="是否限时" prop="open">
                <el-select v-model.number="extraData.open" placeholder="请选择">
                  <el-option v-for="item in openPushType" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item prop="open">
                <el-button type="primary" style="margin-left: 16px;" @click="drawerAct = true">配置时间</el-button>
                <el-drawer title="配置时间" :visible.sync="drawerAct" :with-header="false" size="750px">
                  <el-form>
                    <el-row v-for="(t1,ti) in extraData.ts" :key="ti" style="margin-top: 10px">
                      <el-form-item label="时间范围">
                        <el-date-picker v-model="t1.s" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 200px" placeholder="开始时间" />
                      </el-form-item>
                      <el-form-item label="-">
                        <el-date-picker v-model="t1.e" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 200px" placeholder="结束时间" />
                      </el-form-item>
                      <el-form-item>
                        <el-button type="danger" @click="delTs(ti)">删除</el-button>
                      </el-form-item>
                    </el-row>
                    <el-button style="margin-top: 10px" type="primary" @click="addTs()">+</el-button>
                  </el-form>
                </el-drawer>
              </el-form-item>
              <el-form-item>
                <el-button v-permisaction="['config:rewardCollectEdit:add']" :disabled="isOnline ===1" type="primary" @click="extraSubmit()">保存</el-button>
              </el-form-item>
            </el-form>
          </el-form-item>
        </el-form>
      </el-card>

      <!--      <act-reward-process :is-online="isOnline ===1" :aid="aid" :typ="actType" />-->
      <el-card class="box-card">
        <el-button v-permisaction="['config:rewardBuildMasterEdit:add']" type="primary" @click="beforeAddLevel()">添加等级</el-button>

        <el-tabs v-model="levelActiveName" tab-position="left" style="height: 100%;" @tab-click="handleClick">
          <el-tab-pane v-for="(tabItem,index) in tabPane" :key="index" :name="tabItem.label" :label="getLabelName(tabItem.label)">
            <template #label>
              <div>{{ getLabelName(tabItem.label) }}</div>
            </template>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!--------  等级配置----->
              <el-form :inline="true">
                <el-form-item label="选择类型">
                  <el-select v-model="tabItem.type" style="width: 150px" placeholder="请选择" @change="(v)=>{return levelChangeType(v, tabItem.label)}">
                    <el-option v-for="item in conditionType" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
                <el-form-item label="数值范围">
                  <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>{return levelChange(v, 1,tabItem.type,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>{return levelChange(v, 0,tabItem.type,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
                <el-button v-permisaction="['config:rewardBuildMasterEdit:add']" type="primary" @click="beforeAddLevel(tabItem.label, index)">添加等级2</el-button>
              </el-form>
              <!--------  等级配置----->

              <!-- 二级等级-->
              <el-card v-if="tabItem.children.length > 0" class="box-card">
                <el-tabs v-model="levelActiveName2" tab-position="left" style="height: 100%;" @tab-click="handleClick">
                  <el-tab-pane v-for="(tabItem1,index) in tabItem.children" :key="index" :name="tabItem1.label" :label="getLabelName(tabItem1.label)">
                    <template #label>
                      <div>
                        {{ getLabelName(tabItem1.label) }} <i class="el-icon-circle-close" style="color:red" @click="delChildren(tabItem.label, index)" />
                      </div>
                    </template>
                    <el-form :inline="true">
                      <el-form-item label="选择类型">
                        <el-select v-model="tabItem1.type" style="width: 150px" placeholder="请选择" @change="(v)=>{return levelChangeType(v, tabItem.label,1,tabItem1.label,index)}">
                          <el-option v-for="item in conditionType" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>
                      </el-form-item>
                      <el-form-item label="数值范围">
                        <el-input v-model.number="tabItem1.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>{return levelChange(v, 1,tabItem1.type,tabItem1.bak_min_level, tabItem1.bak_max_level,1,tabItem.label,tabItem1.label)}" />
                      </el-form-item>
                      <el-form-item label="-">
                        <el-input v-model.number="tabItem1.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>{return levelChange(v, 0,tabItem1.type,tabItem1.bak_min_level, tabItem1.bak_max_level,1,tabItem.label,tabItem1.label)}" />
                      </el-form-item>
                    <!--                      <el-button v-permisaction="['config:rewardBuildMasterEdit:add']" type="primary" @click="beforeAddLevel(tabItem1.label, index)">添加等级2</el-button>-->
                    </el-form>

                    <el-button style="margin: 10px 0 10px 0" @click="addScoreEvent(tabItem1.label,tabItem.label, index)">+分组</el-button>
                    <el-form>
                      <el-row v-for="(scoreItem, scoreIndex) in tabItem1.data" :key="scoreIndex">
                        <el-card class="box-card" style="margin-top: 10px">
                          <div slot="header" class="clearfix" style="height: 60px;">
                            <el-form :inline="true">
                              <el-form-item label="选择分组">
                                <el-select v-model="scoreItem.group_bak" multiple placeholder="请选择" style="width: 500px;" @change="(v)=>{return groupChange(v,tabItem.label,scoreItem.group_name,1,index,scoreIndex)}">
                                  <el-option v-for="item in groups" :key="item.value" :label="item.label" :value="item.value" />
                                </el-select>
                              </el-form-item>
                            </el-form>
                          </div>
                          <el-form style="margin: 15px 0">
                            <el-table size="small" :data="scoreItem.data[0].rewards.regulate" border stripe>
                              <el-table-column align="center" label="调控系数">
                                <el-table-column prop="percent" header-align="center" label="上一期完成度(%)">
                                  <template v-slot:default="scope">
                                    <el-input-number v-model.number="scope.row.lastTimesMin" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="上一期完成度" />
                                    -
                                    <el-input-number v-model.number="scope.row.lastTimesMax" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="上一期完成度" />
                                  </template>
                                </el-table-column>
                                <el-table-column prop="percent" header-align="center" label="干涉层级(%)">
                                  <template v-slot:default="scope">
                                    <el-input-number v-model.number="scope.row.controlMin" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="干涉层级" />
                                    -
                                    <el-input-number v-model.number="scope.row.controlMax" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="干涉层级" />
                                  </template>
                                </el-table-column>
                                <el-table-column prop="percent" header-align="center" label="进度参数(%)">
                                  <template v-slot:default="scope">
                                    <el-input-number v-model.number="scope.row.progressMin" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="干涉层级" />
                                    -
                                    <el-input-number v-model.number="scope.row.progressMax" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="干涉层级" />
                                  </template>
                                </el-table-column>
                              </el-table-column>
                            </el-table>
                            <el-button style="margin-top: 10px" type="primary" @click="addRegulate(scoreItem.data[0].rewards,true)">+</el-button>
                            <el-button style="margin-top: 10px" type="danger" @click="addRegulate(scoreItem.data[0].rewards,false)">-</el-button>
                          </el-form>
                          <el-form style="margin: 15px 0">
                            <el-table size="small" :data="scoreItem.data[0].rewards.heightBetControl" border stripe>
                              <el-table-column align="center" label="高倍率调控系数">
                                <el-table-column prop="percent" header-align="center" label="倍率">
                                  <template v-slot:default="scope">
                                    <el-input-number v-model.number="scope.row.bet" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="倍率" />
                                  </template>
                                </el-table-column>
                                <el-table-column prop="percent" header-align="center" label="系数">
                                  <template v-slot:default="scope">
                                    <el-input-number v-model.number="scope.row.ce" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="系数" />
                                  </template>
                                </el-table-column>
                              </el-table-column>
                            </el-table>
                            <el-button style="margin-top: 10px" type="primary" @click="addHeightBetControl(scoreItem.data[0].rewards.heightBetControl,true)">+</el-button>
                            <el-button style="margin-top: 10px" type="danger" @click="addHeightBetControl(scoreItem.data[0].rewards.heightBetControl,false)">-</el-button>
                          </el-form>
                          <!--  修正系数-->
                          <el-table :data="scoreItem.data[0].stageCoefficient" border style="width: 100%">
                            <el-table-column>
                              <template v-slot:default="scope">
                                {{ scope.row[index] }}
                              </template>
                            </el-table-column>
                          </el-table>
                          <!-- 修正系数-->
                          <el-form style="margin-top: 15px">
                            <el-table size="small" :data="[scoreItem.data[0].rewards.trigger]" border stripe>
                              <el-table-column align="center" label="个人加赠">
                                <el-table-column prop="stage" label="每天触发次数">
                                  <template v-slot:default="scope">
                                    <el-input v-model.number="scope.row.dayLimit" placeholder="阶段" />
                                  </template>
                                </el-table-column>
                                <el-table-column prop="ts" label="触发间隔时长(分)">
                                  <template v-slot:default="scope">
                                    <el-input v-model.number="scope.row.intervalTime" placeholder="时间" />
                                  </template>
                                </el-table-column>
                                <el-table-column prop="percent" label="进度百分比">
                                  <template v-slot:default="scope">
                                    <el-input v-model.number="scope.row.minPercent" style="width: 47%" placeholder="进度最低百分比" />
                                    -
                                    <el-input v-model.number="scope.row.maxPercent" style="width: 47%" placeholder="进度最大百分比" />
                                  </template>
                                </el-table-column>
                                <el-table-column prop="coefficient" label="系数">
                                  <template v-slot:default="scope">
                                    <el-input v-model.number="scope.row.coefficient" placeholder="系数" />
                                  </template>
                                </el-table-column>
                              </el-table-column>
                            </el-table>
                          </el-form>
                          <el-form style="margin-top: 15px">
                            <!--   加赠-->
                            <el-table size="small" :data="scoreItem.data[0].rewards.cond" border stripe>
                              <el-table-column align="center" label="超级加赠配置">
                                <el-table-column prop="stage" label="开启阶段">
                                  <template v-slot:default="scope">
                                    <el-input v-model.number="scope.row.stage" placeholder="阶段" />
                                  </template>
                                </el-table-column>
                                <el-table-column prop="ts" label="时间(分钟)">
                                  <template v-slot:default="scope">
                                    <el-input v-model.number="scope.row.ts" placeholder="时间" />
                                  </template>
                                </el-table-column>
                                <el-table-column prop="percent" label="进度百分比">
                                  <template v-slot:default="scope">
                                    <el-input v-model.number="scope.row.minPercent" style="width: 47%" placeholder="进度最低百分比" />
                                    -
                                    <el-input v-model.number="scope.row.maxPercent" style="width: 47%" placeholder="进度最大百分比" />
                                  </template>
                                </el-table-column>
                                <el-table-column prop="coefficient" label="系数">
                                  <template v-slot:default="scope">
                                    <el-input v-model.number="scope.row.coefficient" placeholder="系数" />
                                  </template>
                                </el-table-column>
                                <el-table-column prop="coefficient" label="操作">
                                  <template v-slot:default="scope">
                                    <el-button style="margin-top: 10px" type="danger" @click="delCond(tabItem.label,index,scoreIndex,1,scope.$index)">删除</el-button>
                                  </template>
                                </el-table-column>
                              </el-table-column>
                            </el-table>
                            <el-button style="margin-top: 10px" type="primary" @click="addCond(tabItem.label,scoreItem.group_name,scoreIndex,1, index)">+</el-button>
                            <div style="margin: 15px 0px" />
                            <!--                      加赠-->

                            <el-table size="small" :data="scoreItem.data[0].rewards.rewards" border stripe>
                              <el-table-column prop="stage" label="阶段">
                                <template v-slot:default="scope">
                                  <el-input v-model.number="scope.row.stage" placeholder="阶段" />
                                </template>
                              </el-table-column>
                              <el-table-column prop="stepnum" label="步骤进度">
                                <template v-slot:default="scope">
                                  <el-input v-model.number="scope.row.stepnum" placeholder="步骤进度" />
                                </template>
                              </el-table-column>
                              <el-table-column prop="progressBarId" label="进度Bar">
                                <template v-slot:default="scope">
                                  <el-input v-model.number="scope.row.progressBarId" placeholder="进度Bar" />
                                </template>
                              </el-table-column>
                              <el-table-column prop="stageSpins" label="最低消耗体力">
                                <template v-slot:default="scope">
                                  <el-input v-model.number="scope.row.stageSpins" placeholder="最低消耗体力" />
                                </template>
                              </el-table-column>
                              <el-table-column label="常规奖励">
                                <template v-slot:default="scope">
                                  {{ getRewardList(scope.row.prize,0) }}
                                </template>
                              </el-table-column>
                              <el-table-column label="限时奖励">
                                <template v-slot:default="scope">
                                  {{ getRewardList(scope.row.prize,1) }}
                                </template>
                              </el-table-column>
                              <el-table-column label="超级加赠奖励">
                                <template v-slot:default="scope">
                                  {{ getRewardList(scope.row.prize,2) }}
                                </template>
                              </el-table-column>
                              <el-table-column label="奖励配置">
                                <template v-slot:default="scope">
                                  <el-button type="text" style="margin-left: 16px;" @click="scope.row.draw = true">奖励配置</el-button>
                                  <el-drawer title="奖励配置" size="1200px" :visible.sync="scope.row.draw" :direction="direction">
                                    <el-form :inline="true">
                                      <el-row v-for="(r, i) in scope.row.prize" :key="i">
                                        <el-form-item label="道具" style="margin-top: 10px;">
                                          <el-select v-model.number="r.type" style="width: 100px;" placeholder="请选择" @change="typeChange">
                                            <el-option v-for="(item, index) in rewardType" :key="index" :label="item.label" :value="item.value" />
                                          </el-select>
                                        </el-form-item>
                                        <el-form-item v-if="skinId.includes(r.type) || activtyToTypeId.includes(r.type)" style="margin-top: 10px;" :label="activtyToTypeId.includes(r.type) ? '选择活动':'选择皮肤'">
                                          <el-select v-if="r.type === 62" v-model.number="r.skin" placeholder="请选择" style="width: 120px">
                                            <el-option v-for="item in chessId" :key="item.value" :label="item.label" :value="item.value" />
                                          </el-select>
                                          <el-select v-if="r.type === 19" v-model.number="r.skin" placeholder="请选择" style="width: 120px">
                                            <el-option v-for="item in areaId" :key="item.value" :label="item.label" :value="item.value" />
                                          </el-select>
                                          <el-select v-if="r.type === 23" v-model.number="r.skin" placeholder="请选择" style="width: 120px">
                                            <el-option v-for="item in avatar" :key="item.value" :label="item.label" :value="item.value" />
                                          </el-select>
                                          <el-select v-if="r.type === 67" v-model.number="r.skin" placeholder="请选择" style="width: 120px">
                                            <el-option v-for="item in shield" :key="item.value" :label="item.label" :value="item.value" />
                                          </el-select>
                                          <el-select v-if="r.type === 68" v-model.number="r.skin" placeholder="请选择" style="width: 120px">
                                            <el-option v-for="item in sieve" :key="item.value" :label="item.label" :value="item.value" />
                                          </el-select>
                                          <el-select v-if="activtyToTypeId.includes(r.type)" v-model.number="r.skin" placeholder="请选择" style="width: 120px">
                                            <el-option v-for="item in activtyList" :key="item.id" :label="item.name" :value="parseInt(item.id)" />
                                          </el-select>
                                        </el-form-item>
                                        <el-form-item label="是否限时" style="margin-top: 10px;">
                                          <el-select v-model.number="r.is_ts" style="width: 100px;" placeholder="请选择">
                                            <el-option v-for="(item, index) in tsType" :key="index" :label="item.label" :value="item.value" />
                                          </el-select>
                                        </el-form-item>
                                        <el-form-item v-if="r.is_ts === 1" label="限时时间" style="margin-top: 10px;">
                                          <el-input v-model.number="r.ts" style="width: 80px;" placeholder="限时时间" />
                                        </el-form-item>
                                        <el-form-item label="奖品数量" style="margin-top: 10px;">
                                          <el-input v-model.number="r.num" style="width: 80px;" placeholder="奖品数量" />
                                        </el-form-item>
                                        <el-form-item style="margin-top: 10px;" label="金币取值">
                                          <el-select v-model.number="r.rtype" :disabled="!goldCard.includes(r.type)" placeholder="请选择" style="width: 120px">
                                            <el-option v-for="item in selectType" :key="item.id" :label="item.title" :value="item.id" />
                                          </el-select>
                                        </el-form-item>
                                        <el-form-item style="margin-top: 10px;">
                                          <el-button v-permisaction="['config:rewardCollectEdit:del']" type="danger" @click="removeReward(tabItem.label,scope.$index,scoreIndex,i,1)">删除</el-button>
                                        </el-form-item>
                                      </el-row>
                                      <el-button v-permisaction="['config:rewardCollectEdit:add']" style="margin-top: 5px" type="primary" @click="addReward(tabItem.label, scope.$index,scoreIndex,1)">+</el-button>
                                    </el-form>
                                  </el-drawer>
                                </template>
                              </el-table-column>
                              <el-table-column>
                                <template v-slot:default="scope">
                                  <el-button style="margin-top: 10px" type="danger" @click="delEvent2(tabItem.label,scoreIndex,scope.$index,1)">删除</el-button>
                                </template>
                              </el-table-column>
                            </el-table>
                            <el-button style="margin-top: 10px" type="primary" @click="addEvent(tabItem.label,scoreItem.group_name,scoreIndex,1, index)">+</el-button>
                            <el-button v-permisaction="['config:rewardBuildMasterEdit:add']" :disabled="isOnline ===1" style="margin-top: 10px" type="primary" @click="onSubmit()">保存</el-button>
                            <el-button style="margin-top: 10px" type="danger" @click="delEvent(tabItem.label,scoreIndex,1,index)">删除</el-button>
                          </el-form>
                        </el-card>
                      </el-row>
                    </el-form>
                  </el-tab-pane>
                </el-tabs>
              <!-- 二级等级-->
              </el-card>
              <el-button style="margin: 10px 0 10px 0" @click="addScoreEvent(tabItem.label,'')">+分组</el-button>
              <el-form>
                <el-row v-for="(scoreItem, scoreIndex) in tabItem.data" :key="scoreIndex">
                  <el-card class="box-card" style="margin-top: 10px">
                    <div slot="header" class="clearfix" style="height: 60px;">
                      <el-form :inline="true">
                        <el-form-item label="选择分组">
                          <el-select v-model="scoreItem.group_bak" multiple placeholder="请选择" style="width: 500px;" @change="(v)=>{return groupChange(v,tabItem.label,scoreItem.group_name)}">
                            <el-option v-for="item in groups" :key="item.value" :label="item.label" :value="item.value" />
                          </el-select>
                        </el-form-item>
                      </el-form>
                    </div>
                    <!-- 修正系数-->
                    <el-form style="margin: 15px 0">
                      <el-table size="small" :data="scoreItem.data[0].rewards.regulate" border stripe>
                        <el-table-column align="center" label="调控系数">
                          <el-table-column prop="percent" header-align="center" label="上一期完成度(%)">
                            <template v-slot:default="scope">
                              <el-input-number v-model.number="scope.row.lastTimesMin" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="上一期完成度" />
                              -
                              <el-input-number v-model.number="scope.row.lastTimesMax" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="上一期完成度" />
                            </template>
                          </el-table-column>
                          <el-table-column prop="percent" header-align="center" label="干涉层级(%)">
                            <template v-slot:default="scope">
                              <el-input-number v-model.number="scope.row.controlMin" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="干涉层级" />
                              -
                              <el-input-number v-model.number="scope.row.controlMax" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="干涉层级" />
                            </template>
                          </el-table-column>
                          <el-table-column prop="percent" header-align="center" label="进度参数(%)">
                            <template v-slot:default="scope">
                              <el-input-number v-model.number="scope.row.progressMin" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="干涉层级" />
                              -
                              <el-input-number v-model.number="scope.row.progressMax" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="干涉层级" />
                            </template>
                          </el-table-column>
                        </el-table-column>
                      </el-table>
                      <el-button style="margin-top: 10px" type="primary" @click="addRegulate(scoreItem.data[0].rewards,true)">+</el-button>
                      <el-button style="margin-top: 10px" type="danger" @click="addRegulate(scoreItem.data[0].rewards,false)">-</el-button>
                    </el-form>
                    <el-form style="margin: 15px 0">
                      <el-table size="small" :data="scoreItem.data[0].rewards.heightBetControl" border stripe>
                        <el-table-column align="center" label="高倍率调控系数">
                          <el-table-column prop="percent" header-align="center" label="倍率">
                            <template v-slot:default="scope">
                              <el-input-number v-model.number="scope.row.bet" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="倍率" />
                            </template>
                          </el-table-column>
                          <el-table-column prop="percent" header-align="center" label="系数">
                            <template v-slot:default="scope">
                              <el-input-number v-model.number="scope.row.ce" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="系数" />
                            </template>
                          </el-table-column>
                        </el-table-column>
                      </el-table>
                      <el-button style="margin-top: 10px" type="primary" @click="addHeightBetControl(scoreItem.data[0].rewards.heightBetControl,true)">+</el-button>
                      <el-button style="margin-top: 10px" type="danger" @click="addHeightBetControl(scoreItem.data[0].rewards.heightBetControl,false)">-</el-button>
                    </el-form>
                    <!--  修正系数-->
                    <el-table :data="scoreItem.data[0].stageCoefficient" border style="width: 100%">
                      <el-table-column v-for="(item, index) in stageCoefficientHeader" :key="index" :label="item">
                        <template v-slot:default="scope">
                          {{ scope.row[index] }}
                        </template>
                      </el-table-column>
                    </el-table>
                    <!-- 修正系数-->
                    <el-form style="margin-top: 15px">
                      <el-table size="small" :data="[scoreItem.data[0].rewards.trigger]" border stripe>
                        <el-table-column align="center" label="个人加赠">
                          <el-table-column prop="stage" label="每天触发次数">
                            <template v-slot:default="scope">
                              <el-input-number v-model.number="scope.row.dayLimit" :controls="false" style="width: 95%;" :min="0" placeholder="阶段" />
                            </template>
                          </el-table-column>
                          <el-table-column prop="ts" label="触发间隔时长(分)">
                            <template v-slot:default="scope">
                              <el-input-number v-model.number="scope.row.intervalTime" :controls="false" style="width: 95%;" :min="0" placeholder="时间" />
                            </template>
                          </el-table-column>
                          <el-table-column prop="percent" label="进度百分比">
                            <template v-slot:default="scope">
                              <el-input-number v-model.number="scope.row.minPercent" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="进度最低百分比" />
                              -
                              <el-input-number v-model.number="scope.row.maxPercent" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="进度最大百分比" />
                            </template>
                          </el-table-column>
                          <el-table-column prop="coefficient" label="系数">
                            <template v-slot:default="scope">
                              <el-input-number v-model.number="scope.row.coefficient" :controls="false" style="width: 95%;" :min="0" placeholder="系数" />
                            </template>
                          </el-table-column>
                        </el-table-column>
                      </el-table>
                    </el-form>
                    <el-form style="margin-top: 15px">
                      <!--   加赠-->
                      <el-table size="small" :data="scoreItem.data[0].rewards.cond" border stripe>
                        <el-table-column align="center" label="超级加赠配置">
                          <el-table-column prop="stage" label="开启阶段">
                            <template v-slot:default="scope">
                              <el-input v-model.number="scope.row.stage" placeholder="阶段" />
                            </template>
                          </el-table-column>
                          <el-table-column prop="ts" label="时间(分钟)">
                            <template v-slot:default="scope">
                              <el-input v-model.number="scope.row.ts" placeholder="时间" />
                            </template>
                          </el-table-column>
                          <el-table-column prop="percent" label="进度百分比">
                            <template v-slot:default="scope">
                              <el-input v-model.number="scope.row.minPercent" style="width: 47%" placeholder="进度最低百分比" />
                              -
                              <el-input v-model.number="scope.row.maxPercent" style="width: 47%" placeholder="进度最大百分比" />
                            </template>
                          </el-table-column>
                          <el-table-column prop="coefficient" label="系数">
                            <template v-slot:default="scope">
                              <el-input v-model.number="scope.row.coefficient" placeholder="系数" />
                            </template>
                          </el-table-column>
                          <el-table-column prop="coefficient" label="操作">
                            <template v-slot:default="scope">
                              <el-button style="margin-top: 10px" type="danger" @click="delCond(tabItem.label,scoreIndex,scope.$index,0)">删除</el-button>
                            </template>
                          </el-table-column>
                        </el-table-column>
                      </el-table>
                      <el-button style="margin-top: 10px" type="primary" @click="addCond(tabItem.label,scoreItem.group_name,scoreIndex,0)">+</el-button>
                      <div style="margin: 15px 0px" />
                      <!--                      加赠-->

                      <el-table size="small" :data="scoreItem.data[0].rewards.rewards" border stripe>
                        <el-table-column prop="stage" label="阶段">
                          <template v-slot:default="scope">
                            <el-input v-model.number="scope.row.stage" placeholder="阶段" />
                          </template>
                        </el-table-column>
                        <el-table-column prop="stepnum" label="步骤进度">
                          <template v-slot:default="scope">
                            <el-input v-model.number="scope.row.stepnum" placeholder="步骤进度" />
                          </template>
                        </el-table-column>
                        <el-table-column prop="progressBarId" label="进度Bar">
                          <template v-slot:default="scope">
                            <el-input v-model.number="scope.row.progressBarId" placeholder="进度Bar" />
                          </template>
                        </el-table-column>
                        <el-table-column prop="stageSpins" label="最低消耗体力">
                          <template v-slot:default="scope">
                            <el-input v-model.number="scope.row.stageSpins" placeholder="最低消耗体力" />
                          </template>
                        </el-table-column>
                        <el-table-column label="常规奖励">
                          <template v-slot:default="scope">
                            {{ getRewardList(scope.row.prize,0) }}
                          </template>
                        </el-table-column>
                        <el-table-column label="限时奖励">
                          <template v-slot:default="scope">
                            {{ getRewardList(scope.row.prize,1) }}
                          </template>
                        </el-table-column>
                        <el-table-column label="超级加赠奖励">
                          <template v-slot:default="scope">
                            {{ getRewardList(scope.row.prize,2) }}
                          </template>
                        </el-table-column>
                        <el-table-column label="奖励配置">
                          <template v-slot:default="scope">
                            <ActReward :value="scope.row.prize" />
                          </template>
                        </el-table-column>
                        <el-table-column>
                          <template v-slot:default="scope">
                            <el-button style="margin-top: 10px" type="danger" @click="delEvent2(tabItem.label,scoreIndex,scope.$index,0)">删除</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                      <el-button style="margin-top: 10px" type="primary" @click="addEvent(tabItem.label,scoreItem.group_name,scoreIndex,0)">+</el-button>
                      <el-button v-permisaction="['config:rewardBuildMasterEdit:add']" :disabled="isOnline ===1" style="margin-top: 10px" type="primary" @click="onSubmit()">保存</el-button>
                      <el-button :disabled="isOnline === 1" style="margin-top: 10px" type="danger" @click="delEvent(tabItem.label,scoreIndex,0)">删除</el-button>
                    </el-form>
                  </el-card>
                </el-row>
              </el-form>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
        <el-dialog title="提示" :visible.sync="dialogVisible" width="500px;">
          <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
            <el-form-item label="选择类型">
              <el-select v-model="levelFormData.type" style="width: 150px" placeholder="请选择">
                <el-option
                  v-for="item in conditionType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="数值">
              <el-input v-model.number="levelFormData.min_level" style="width: 100px;" placeholder="最小值" />
            </el-form-item>
            <el-form-item label="-">
              <el-input v-model.number="levelFormData.max_level" style="width: 100px;" placeholder="最大值" />
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="addLevel()">保存</el-button>
          </span>
        </el-dialog>

        <el-dialog
          title="提示"
          :visible.sync="dialogVisibleScoreEvent"
          width="500px"
        >
          <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
            <el-form-item label="选择分组">
              <el-select v-model="scoreFormData.group" style="width: 150px" multiple placeholder="请选择">
                <el-option
                  v-for="item in groups"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleScoreEvent = false">取 消</el-button>
            <el-button type="primary" @click="addGroup()">保存</el-button>
          </span>
        </el-dialog>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import Vue from 'vue'
import CommonExport from '@/components/CommonExport/index.vue'
import { getRewardType } from '@/api/config/slot'
import {
  exportStageCoefficientCfg, getActivityAllList, getActivityList,
  getActivityRewardCfg,
  getConditionTypesList, getStageCoefficientList,
  importActivityStageCoefficientCfg, updateActivityExtraData,
  updateActivityRewardCfg
} from '@/api/config/activity-cfg'
import { getToken } from '@/utils/auth'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { getRewardListForType } from '@/utils'
import ActReward from '@/components/Reward/act.vue'
export default {
  name: 'RewardBuilderMasterEdit',
  components: {
    ActReward,
    CommonExport
  },
  data() {
    return {
      isOnline: 0,
      stageCoefficient: [],
      stageCoefficientHeader: ['阶段', '进度1', '系数1', '进度2', '系数2', '进度3', '系数3', '进度4', '系数4'],
      skinId: [62, 19, 23, 67, 68],
      goldCard: [14, 13, 69, 70, 50, 49, 48],
      chessId: [],
      areaId: [],
      avatar: [],
      shield: [],
      sieve: [],
      ucType: 0,
      loading: false,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      aid: 0,
      tabPane: [],
      shopSku: [],
      visibleArr: {},
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      tsType: [
        {
          'value': 2,
          'label': '超级'
        },
        {
          'value': 1,
          'label': '限时'
        },
        {
          'value': 0,
          'label': '不限时'
        }
      ],
      drawerAct: false,
      openPushType: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
      colorType: [
        {
          'value': 1,
          'label': '绿色'
        },
        {
          'value': 2,
          'label': '蓝色'
        },
        {
          'value': 3,
          'label': '紫色'
        },
        {
          'value': 4,
          'label': '橙色'
        },
        {
          'value': 5,
          'label': '金色'
        }
      ],
      iconType: [
        {
          'value': '1f7bac',
          'label': '奥运'
        },
        {
          'value': 'c6283c',
          'label': '复活节'
        },
        {
          'value': '8f420f',
          'label': '感恩节'
        },
        {
          'value': 'e52619',
          'label': '兰博基尼'
        },
        {
          'value': 'd24fc5',
          'label': '披萨'
        },
        {
          'value': '9c5e68',
          'label': '巧克力'
        },
        {
          'value': 'd63945',
          'label': '圣诞节'
        },
        {
          'value': 'ee4b57',
          'label': '圣帕特里克'
        },
        {
          'value': '7b48b7',
          'label': '万圣节'
        },
        {
          'value': '29adea',
          'label': '夏日海岸'
        }
      ],
      extraData: {
        isShowSpine: 0,
        colorType: 1,
        iconType: 1,
        open: 0,
        ts: [
          { s: '', e: '' }
        ]
      },
      tabPaneTemp: {
        label: '',
        type: '',
        bak_type: '',
        min_level: 0,
        max_level: 0,
        bak_min_level: 0,
        bak_max_level: 0,
        children: [],
        data: []
      },
      drawer: {},
      direction: 'rtl',
      rewardType: [],
      chessBoardType: [],
      groups: [
        { label: '默认分组', value: 0 }
      ],
      conditionType: [],
      actType: '',
      appearType: [
        { 'label': '否', value: 0 },
        { 'label': '是', value: 1 }
      ],
      dialogVisible: false,
      dialogVisibleScoreEvent: false,
      levelFormData: {
        min_level: 0,
        max_level: 0,
        type: 'level',
        parent: '',
        index: 0
      },
      scoreFormData: {
        group: [],
        parent: '',
        group_name: '',
        group_bak: [],
        level_name: '',
        index: 0,
        event_name: ''
      },
      modelName: 'first',
      activeName: 'first',
      levelActiveName: '',
      levelActiveName2: '',
      copyFormData: {},
      formData: {},
      activtyToType: [],
      activtyToTypeId: [],
      activtyList: [],
      defaultLimitRewardTrigger: {
        dayLimit: 0,
        intervalTime: 0,
        minPercent: 0,
        maxPercent: 0,
        coefficient: 0
      },
      defaultRegulate: {
        lastTimesMin: 0,
        lastTimesMax: 0,
        controlMin: 0,
        controlMax: 0,
        progressMin: 0,
        progressMax: 0
      }
    }
  },
  created() {
    this.getConditionTypeData()
    this.aid = this.$route.query.id
    this.actType = this.$route.query.type
    this.ucType = this.$route.query.uc_type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.typeChange('')
    this.getTables()
    this.getRewardTypeData(1)
    this.getGroup()
    this.getAct()
  },
  methods: {
    exportStageCoefficientCfg,
    importActivityStageCoefficientCfg,
    beforeAddLevel(parent = '', index = -1) {
      this.dialogVisible = true
      this.levelFormData.parent = parent
      this.levelFormData.index = index
    },
    bugChange(v, levelName, scoreName, index) {
      if (v === 1) {
        this.formData[levelName][scoreName].data[0].rewards[index].sku = this.coinType[0].value
        this.formData[levelName][scoreName].data[0].rewards[index].price = this.shopSku[0].value
      } else {
        this.formData[levelName][scoreName].data[0].rewards[index].sku = this.shopSku[0].sku
        this.formData[levelName][scoreName].data[0].rewards[index].price = this.shopSku[0].value
      }
    },
    priceChange(v, levelName, scoreName, index) {
      let sku = ''
      this.shopSku.forEach((item) => {
        if (item.value === v) {
          sku = item.sku
        }
      })
      this.formData[levelName][scoreName].data[0].rewards[index].sku = sku
    },
    getConditionTypeData() {
      getConditionTypesList({ data: 1 }).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.conditionType.push({ 'label': res.data[i], 'value': i })
          }
        }
      })
    },
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    handleClose(done, levelName, scoreName, index) {
      this.drawer[levelName][scoreName][index].visible = false
    },
    onSubmit() {
      const postFormDataCondition = {}
      const _postData = []
      let levelIndex = 0
      for (const i in this.tabPane) {
        const tabPane = this.tabPane[i]
        levelIndex++
        let childrenIndex = 0
        for (const i2 in tabPane.children) {
          childrenIndex++
          const childrenData = tabPane.children[i2]
          const [pType, pMinLevel, pMaxLevel] = tabPane.label.split('-')
          const parentCond = {
            start: parseInt(pMinLevel),
            end: parseInt(pMaxLevel),
            shushu: [],
            type: pType
          }
          const [type, minLevel, maxLevel] = childrenData.label.split('-')
          let groupIndex = 0
          for (const i3 in childrenData.data) {
            const data = childrenData.data[i3]
            if (data.data.length <= 0) {
              continue
            }
            groupIndex++
            for (const i4 in data.data) {
              const _rewards = data.data[i4]
              for (const i5 in _rewards.rewards) {
                const _reward = _rewards.rewards[i5]
                // console.log('_reward----', _reward)
                for (const r in _reward) {
                  const list = _reward[r]
                  if (list.stage <= 0) {
                    this.msgError('阶段不能是0')
                    return
                  }
                  if (list.stepnum <= 0) {
                    this.msgError('步骤进度不能是0')
                    return
                  }

                  for (const rk in list.prize) {
                    const p = list.prize[rk]
                    if (p.type === 65) {
                      list.prize[rk].num *= 10000
                    }
                  }
                  _reward[r] = list
                }
                _rewards.rewards[i5] = _reward
              }
            }

            const condition = {
              start: parseInt(minLevel),
              end: parseInt(maxLevel),
              shushu: [],
              type: type
            }

            const condition1 = {
              start: 0,
              end: 0,
              shushu: data.group,
              type: 'shushu'
            }

            const key = `${levelIndex}-${childrenIndex}-${groupIndex}`
            postFormDataCondition[key] = [parentCond, condition, condition1]

            const _data = data.data[0]
            _data.aid = this.aid
            _data.stage = key
            _postData.push(_data)
          }
        }

        for (const i6 in tabPane.data) {
          childrenIndex++
          const data1 = tabPane.data[i6]
          for (const i7 in data1.data) {
            const _rewards = data1.data[i7]
            for (const i5 in _rewards.rewards) {
              const _reward = _rewards.rewards[i5]
              for (const r in _reward) {
                const list = _reward[r]
                if (list.stage <= 0) {
                  this.msgError('阶段不能是0')
                  return
                }
                if (list.stepnum <= 0) {
                  this.msgError('步骤进度不能是0')
                  return
                }

                for (const rk in list.prize) {
                  const p = list.prize[rk]
                  if (p.type === 65) {
                    list.prize[rk].num *= 10000
                  }
                }
                _reward[r] = list
              }
              _rewards.rewards[i5] = _reward
            }
          }

          const [type, minLevel, maxLevel] = tabPane.label.split('-')
          const condition = {
            start: parseInt(minLevel),
            end: parseInt(maxLevel),
            shushu: [],
            type: type
          }

          const condition1 = {
            start: 0,
            end: 0,
            shushu: data1.group,
            type: 'shushu'
          }

          const key = levelIndex + '-' + childrenIndex
          postFormDataCondition[key] = [condition, condition1]

          const _data = data1.data[0]
          _data.aid = this.aid
          _data.stage = key
          _postData.push(_data)
        }
      }
      const postCondition = JSON.stringify({ aid: this.aid, condition: postFormDataCondition })
      const newPostData = JSON.parse(JSON.stringify(_postData))
      for (const i in newPostData) {
        const val = newPostData[i]
        const rewards = val.rewards.rewards
        const cond = val.rewards.cond
        const trigger = val.rewards.trigger
        const regulate = val.rewards.regulate
        const heightBetControl = val.rewards.heightBetControl
        newPostData[i].rewards = rewards
        newPostData[i].cond = cond
        newPostData[i].trigger = trigger
        newPostData[i].regulate = regulate
        newPostData[i].heightBetControl = heightBetControl
      }

      const postFormData = JSON.stringify(newPostData)
      updateActivityRewardCfg({ id: this.aid, type: this.actType, name: postCondition, data: postFormData }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    createParentTabPent(val) {
      const parentTemp = {
        label: '',
        type: '',
        bak_type: '',
        min_level: 0,
        max_level: 0,
        bak_min_level: 0,
        bak_max_level: 0,
        children: [],
        data: []
      }
      parentTemp.label = `${val.type}-${val.start}-${val.end}`
      parentTemp.type = val.type
      parentTemp.bak_type = val.type
      parentTemp.min_level = val.start
      parentTemp.max_level = val.end
      parentTemp.bak_min_level = val.start
      parentTemp.bak_max_level = val.end
      for (const i in this.tabPane) {
        const tabPane = this.tabPane[i]
        if (tabPane.label === parentTemp.label) {
          return
        }
      }
      this.tabPane.push(parentTemp)
    },
    createChildrenTabPent(label, children, group) {
      const tabPane = this.getTabPane(label)
      for (const i in tabPane.children) {
        const val = tabPane.children[i]
        if (val.label === children.label) {
          // 分组是否存在
          for (const i2 in val.data) {
            const g = val.data[i2]
            if (g.group_name === group.group_name) {
              return
            }
          }
          val.data.push(group)
          tabPane.children[i] = val
          return
        }
      }
      children.data.push(group)
      tabPane.children.push(children)
    },
    createTabPen(tabPane, obj) {
      for (const i in tabPane.data) {
        const val = tabPane.data[i]
        if (val.group_name === obj.group_name) {
          return
        }
      }
      tabPane.data.push(obj)
    },
    getStageCoefficient(id) {
      getStageCoefficientList({ id: id }).then(res => {
        if (res.code === 200) {
          this.stageCoefficient = res.data
        }
      })
    },
    getTables() {
      this.getStageCoefficient(this.aid)
      getActivityRewardCfg({ id: this.aid }).then(res => {
        this.tabPane = []
        const cond = res.data.cond.condition
        const data = res.data.data
        for (let i = 0; i < data.length; i++) {
          if (!data[i].rewards.regulate) {
            data[i].rewards.regulate = []
          }
          if (!data[i].rewards.heightBetControl) {
            data[i].rewards.heightBetControl = []
          }
        }
        for (const i in cond) {
          const condLen = cond[i].length
          const val = cond[i][0]
          const val1 = cond[i][1]
          this.createParentTabPent(val)
          let id = 0
          let reward = [{ aid: 0, stage: [], rewards: [], cond: [], stageCoefficient: [], trigger: this.defaultLimitRewardTrigger, regulate: [this.defaultRegulate], heightBetControl: [] }]
          const parentLabel = `${val.type}-${val.start}-${val.end}`
          const tabPane = this.getTabPane(parentLabel)
          this.levelActiveName = parentLabel
          for (const k in data) {
            const _data = data[k]
            if (_data.stage === i) {
              for (const i1 in _data.rewards.rewards) {
                const reward = _data.rewards.rewards[i1]
                for (const r in reward.prize) {
                  if (reward.prize[r].type === 65) {
                    _data.rewards.rewards[i1].prize[r].num /= 10000
                  }
                }
                _data.rewards.rewards[i1].draw = false
              }
              _data.stageCoefficient = this.getStageCoefficientConfig(_data.stage)
              reward = [_data]
              id = _data.id
              break
            }
          }
          if (condLen > 2) {
            const val2 = cond[i][2]
            const parentTemp = Object.assign({}, this.tabPaneTemp)
            parentTemp.bak_min_level = val1.start
            parentTemp.bak_max_level = val1.end
            parentTemp.min_level = val1.start
            parentTemp.max_level = val1.end
            parentTemp.type = val1.type
            parentTemp.bak_type = val1.type
            parentTemp.label = `${val1.type}-${val1.start}-${val1.end}`
            parentTemp.data = []
            parentTemp.children = []
            const group = {
              'group': val2.shushu,
              'group_name': val2.shushu.join('-'),
              'group_bak': val2.shushu,
              'data': reward,
              id: id
            }
            // parentTemp.data.push(group)
            this.createChildrenTabPent(parentLabel, parentTemp, group)
            this.levelActiveName2 = parentTemp.label
          } else {
            this.createTabPen(tabPane, {
              'group': val1.shushu,
              'group_name': val1.shushu.join('-'),
              'group_bak': val1.shushu,
              'data': reward,
              id: id
            })
          }
        }

        console.log('this.tabPane', this.tabPane)
      })
    },
    getStageCoefficientDefaultConfig(stage) {
      for (const i in this.stageCoefficient) {
        const val = this.stageCoefficient[i]
        if (val.stage === stage) {
          return val.config
        }
      }
      return []
    },
    getStageCoefficientConfig(stage) {
      let stageConfig = []
      for (const i in this.stageCoefficient) {
        const val = this.stageCoefficient[i]
        if (val.stage === stage) {
          stageConfig = val.config
          break
        }
      }
      const newStageConfig = []
      for (const i in stageConfig) {
        newStageConfig[i] = []
        const val = stageConfig[i]
        const index = parseInt(i) + 1
        newStageConfig[i].push(index)
        for (const k in val) {
          const stage = val[k]
          newStageConfig[i].push(stage.progress, stage.coefficient)
        }
      }
      return newStageConfig
    },
    levelChangeType(newVal, levelName, isParent = 0, levelName2) {
      // 是否存在相同类型
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === levelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })

      if (fileIndex === -1) {
        this.msgError('修改失败')
        return
      }

      const oldTabPane = this.tabPane[fileIndex]
      let newLabelName = newVal + '-' + oldTabPane.min_level + '-' + oldTabPane.max_level
      if (!isParent) {
        for (const i in this.tabPane) {
          const tabPane = this.tabPane[i]
          if (tabPane.label === newLabelName) {
            this.msgError('当前类型配置已经存在')
            return
          }
        }
        oldTabPane.label = newLabelName
        this.tabPane[fileIndex] = oldTabPane
        this.levelActiveName = newLabelName
      } else {
        if (oldTabPane.label === newLabelName) {
          this.msgError('当前类型配置不能与父类型一致')
          return
        }
        let childrenTabPane = []
        let childrenTabIndex = 0
        for (const i in oldTabPane.children) {
          const val = oldTabPane.children[i]
          if (val.label === newLabelName) {
            this.msgError('当前类型配置已经存在')
            return
          }
        }

        for (const i in oldTabPane.children) {
          const val = oldTabPane.children[i]
          if (val.label === levelName2) {
            childrenTabPane = val
            childrenTabIndex = i
            break
          }
        }
        newLabelName = newVal + '-' + childrenTabPane.min_level + '-' + childrenTabPane.max_level
        childrenTabPane.label = newLabelName
        this.tabPane[fileIndex].children[childrenTabIndex] = childrenTabPane
        this.levelActiveName2 = newLabelName
      }
    },
    levelChange(newVal, isMin, type, bakMin, bakMax, isParent = 0, parentLabel, levelName2) {
      newVal = parseInt(newVal)
      let oldLevelName = type + '-' + bakMin + '-' + bakMax
      if (isParent) {
        oldLevelName = parentLabel
      }
      let newLevelName = ''
      if (isMin) {
        newLevelName = type + '-' + newVal + '-' + bakMax
      } else {
        newLevelName = type + '-' + bakMin + '-' + newVal
      }
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === oldLevelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })
      console.log(fileIndex)
      if (fileIndex > -1) {
        const oldTab = this.tabPane[fileIndex]
        let childrenTabPane = []
        let childrenTabIndex = 0
        if (isParent) {
          for (const i in oldTab.children) {
            const val = oldTab.children[i]
            if (val.label === levelName2) {
              childrenTabPane = val
              childrenTabIndex = i
              break
            }
          }

          if (isMin) {
            childrenTabPane['bak_min_level'] = newVal
            childrenTabPane['min_level'] = newVal
          } else {
            childrenTabPane['bak_max_level'] = newVal
            childrenTabPane['max_level'] = newVal
          }
          childrenTabPane['label'] = newLevelName
          this.tabPane[fileIndex].children[childrenTabIndex] = childrenTabPane
          this.levelActiveName2 = newLevelName
        } else {
          oldTab['label'] = newLevelName
          if (isMin) {
            oldTab['bak_min_level'] = newVal
            oldTab['min_level'] = newVal
          } else {
            oldTab['bak_max_level'] = newVal
            oldTab['max_level'] = newVal
          }
          this.tabPane[fileIndex] = oldTab
          this.levelActiveName = newLevelName
        }
      }
    },
    addEventReward(levelName, scoreName, index, i) {
      console.log(this.formData[levelName][scoreName].data[index].config[i])
      let propsId = 14
      if (this.formData[levelName][scoreName].data[index].config[i].type === 3) {
        propsId = 1
        if (this.formData[levelName][scoreName].data[index].config[i].reward.length >= 1) {
          return
        }
      }
      this.formData[levelName][scoreName].data[index].config[i].reward.push({
        propsId: propsId,
        skin: 0,
        num: 0,
        rtype: 2
      })
    },
    addEvent1(levelName, scoreName, index) {
      this.formData[levelName][scoreName].data[index].config.push({
        aid: 1,
        reward: [{
          state: 1,
          stepnum: 1,
          prize: [
            {
              id: 1,
              num: 1,
              skin: 0,
              rtype: 2,
              type: 2,
              is_ts: 0
            }],
          progressBarId: 1,
          stageSpins: 1
        }],
        stage: []
      })
    },
    delEvent1(levelName, index, scoreIndex, isParent = false) {
      const tabPane = this.getTabPane(levelName)
      if (!tabPane) {
        this.msgError('添加失败,未找到元素')
        return
      }

      tabPane.data[scoreIndex].data[0].rewards = tabPane.data[scoreIndex].data[0].rewards.filter((item, key) => {
        return index !== key
      })

      let count = 0
      tabPane.data[scoreIndex].data[0].rewards.forEach((res, index) => {
        count++
        tabPane.data[scoreIndex].data[0].rewards[index].stage = count
      })
    },
    addCond(levelName, scoreName, scoreIndex, isParent = 0, parentIndex = 0) {
      const tabPane = this.getTabPane(levelName)
      if (!tabPane) {
        this.msgError('添加失败,未找到元素')
        return
      }

      console.log('parentIndex', parentIndex)
      // console.log('cond', tabPane.children[parentIndex].data[scoreIndex].data[0].rewards.cond)
      if (isParent) {
        tabPane.children[parentIndex].data[scoreIndex].data[0].rewards.cond.push({
          ts: 0,
          stage: 0,
          minPercent: 0,
          maxPercent: 0,
          coefficient: 0
        })
      } else {
        tabPane.data[scoreIndex].data[0].rewards.cond.push({
          ts: 0,
          stage: 0,
          minPercent: 0,
          maxPercent: 0,
          coefficient: 0
        })
      }
    },
    delCond(levelName, scoreIndex, index, isParent = 0, parentIndex = 0) {
      const tabPane = this.getTabPane(levelName)
      if (!tabPane) {
        this.msgError('删除失败,未找到元素')
        return
      }

      if (isParent) {
        console.log('cond', tabPane.children[scoreIndex].data[index].data[0].rewards.cond)
        tabPane.children[scoreIndex].data[index].data[0].rewards.cond = tabPane.children[scoreIndex].data[index].data[0].rewards.cond.filter((item, idx) => {
          return index !== idx
        })
      } else {
        tabPane.data[scoreIndex].data[0].rewards.cond = tabPane.data[scoreIndex].data[0].rewards.cond.filter((item, idx) => {
          return idx !== index
        })
      }
    },
    delEvent2(levelName, scoreIndex, index, isParent = 0, parentIndex = 0) {
      const tabPane = this.getTabPane(levelName)
      if (!tabPane) {
        this.msgError('删除失败,未找到元素')
        return
      }

      if (isParent) {
        tabPane.children[parentIndex].data[scoreIndex].data[0].rewards.rewards = tabPane.children[parentIndex].data[scoreIndex].data[0].rewards.rewards.filter((item, idx) => {
          return index !== idx
        })
      } else {
        tabPane.data[scoreIndex].data[0].rewards.rewards = tabPane.data[scoreIndex].data[0].rewards.rewards.filter((item, idx) => {
          return idx !== index
        })
      }
    },
    addEvent(levelName, scoreName, scoreIndex, isParent = 0, parentIndex = 0) {
      const tabPane = this.getTabPane(levelName)

      if (!tabPane) {
        this.msgError('添加失败,未找到元素')
        return
      }

      if (isParent) {
        const len = tabPane.children[parentIndex].data[scoreIndex].data[0].rewards.rewards.length
        tabPane.children[parentIndex].data[scoreIndex].data[0].rewards.rewards.push({
          draw: false,
          stage: len + 1,
          stepnum: 1,
          lv: 1,
          stagePro: [],
          prize: [],
          progressBarId: 1,
          stageSpins: 1
        })
      } else {
        const len = tabPane.data[scoreIndex].data[0].rewards.rewards.length
        tabPane.data[scoreIndex].data[0].rewards.rewards.push({
          draw: false,
          stage: len + 1,
          stepnum: 1,
          lv: 1,
          stagePro: [],
          prize: [],
          progressBarId: 1,
          stageSpins: 1
        })
      }
    },
    delEvent(levelName, scoreIndex, isParent = 0, index = 0) {
      const tabPane = this.getTabPane(levelName)
      if (isParent) {
        tabPane.children[index].data = tabPane.children[index].data.filter((item, idx) => {
          return idx !== scoreIndex
        })
      } else {
        tabPane.data = tabPane.data.filter((item, index) => {
          return index !== scoreIndex
        })
      }
    },
    addScoreEvent(levelName, parent, index) {
      this.scoreFormData.max_score = 0
      this.scoreFormData.min_score = 0
      this.scoreFormData.parent = parent
      this.scoreFormData.index = index
      this.scoreFormData.level_name = levelName
      this.dialogVisibleScoreEvent = true
    },
    addGroup() {
      const score = this.scoreFormData
      const parent = score.parent
      const index = score.index
      console.log('parent', parent)
      if (score.group.length <= 0) {
        this.msgError('请选择分组')
        return
      }
      this.dialogVisibleScoreEvent = false
      const bakGroup = score.group
      const scoreTag = score.group.join('-')
      let label = score.level_name
      if (parent !== '') {
        label = parent
      }
      let tabPaneEdit = []
      for (const i in this.tabPane) {
        const tabPane = this.tabPane[i]
        if (tabPane.label === label) {
          tabPaneEdit = tabPane
          break
        }
      }

      if (!tabPaneEdit) {
        this.msgError('添加失败,未找到元素')
        return
      }

      if (parent !== '') {
        for (const i in tabPaneEdit.children[index].data) {
          const g = tabPaneEdit.children[index].data[i]
          if (g.group_name === scoreTag) {
            this.msgError('添加失败,当前分组已经存在')
            return
          }
        }
        tabPaneEdit.children[index].data.push({
          'group': bakGroup,
          'group_name': scoreTag,
          'group_bak': bakGroup,
          'data': [{ aid: 0, stageCoefficient: [], stage: [], rewards: { rewards: [], cond: [], trigger: this.defaultLimitRewardTrigger, regulate: [this.defaultRegulate], heightBetControl: [] }}]
        })
      } else {
        for (const i in tabPaneEdit.data) {
          const g = tabPaneEdit.data[i]
          if (g.group_name === scoreTag) {
            this.msgError('添加失败,当前分组已经存在')
            return
          }
        }
        tabPaneEdit.data.push({
          'group': bakGroup,
          'group_name': scoreTag,
          'group_bak': bakGroup,
          'data': [{ aid: 0, stageCoefficient: [], stage: [], rewards: { rewards: [], cond: [], trigger: this.defaultLimitRewardTrigger, regulate: [this.defaultRegulate], heightBetControl: [] }}]
        })
      }

      // 添加第一个元素
      this.activeName = score.level_name
      this.scoreFormData.group = []
      this.scoreFormData.group_bak = []
      this.scoreFormData.group_name = ''
    },
    addLevel() {
      const parent = this.levelFormData.parent
      const index = this.levelFormData.index
      this.dialogVisible = false
      if (this.levelFormData.min_level > this.levelFormData.max_level) {
        this.msgError('最低等级不能大于最大等级')
        return
      }
      const levelName = this.levelFormData.type + '-' + this.levelFormData.min_level + '-' + this.levelFormData.max_level
      if (parent !== '') {
        if (this.tabPane[index].label === levelName) {
          this.msgError('父级类型不能和当前所有类型相同')
          return
        }
        for (const i in this.tabPane[index].children) {
          const tabPane = this.tabPane[index].children[i]
          if (tabPane.type === this.levelFormData.type && tabPane.label === levelName) {
            this.msgError('当前配置已经存在')
            return
          }
        }
      } else {
        for (const i in this.tabPane) {
          const tabPane = this.tabPane[i]
          if (tabPane.type === this.levelFormData.type && tabPane.label === levelName) {
            this.msgError('当前配置已经存在')
            return
          }
        }
      }

      const tabPane = {
        label: levelName,
        type: this.levelFormData.type,
        bak_type: this.levelFormData.type,
        min_level: this.levelFormData.min_level,
        max_level: this.levelFormData.max_level,
        bak_min_level: this.levelFormData.min_level,
        bak_max_level: this.levelFormData.max_level,
        children: [],
        data: []
      }

      if (index > -1) {
        this.tabPane[index].children.push(tabPane)
        this.levelActiveName2 = levelName
      } else {
        this.tabPane.push(tabPane)
        this.levelActiveName = levelName
      }
    },
    handleClick(tab, event) {
      console.log(tab.name)
      this.activeName = tab.name
    },
    scoreChange(newVal, isMin, levelName, minBak, maxBak) {
      console.log('scoreChange', newVal)
      const oldScoreName = minBak + '-' + maxBak
      let newScoreName = newVal + '-' + maxBak
      if (!isMin) {
        newScoreName = minBak + '-' + newVal
      }
      const oldData = this.formData[levelName][oldScoreName]

      if (isMin) {
        oldData.min_score = newVal
        oldData.min_score_bak = newVal
      } else {
        oldData.max_score = newVal
        oldData.max_score_bak = newVal
      }

      // // 删除旧积分
      Vue.delete(this.formData[levelName], oldScoreName)
      this.$set(this.formData[levelName], newScoreName, oldData)
      console.log(this.formData[levelName])
    },
    getRewardTypeData(uc_type) {
      getRewardType({ data: uc_type }).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    addReward(levelName, index, scoreIndex, isParent = false, parentIndex = 0) {
      const tabPane = this.getTabPane(levelName)
      if (!tabPane) {
        this.msgError('奖励添加失败,未找到元素')
        return
      }
      if (isParent) {
        tabPane.children[parentIndex].data[scoreIndex].data[0].rewards.rewards[index].prize.push(
          {
            id: 0,
            num: 0,
            type: 1,
            rtype: 1,
            is_ts: 0,
            skin: 0,
            ts: 0
          }
        )
      } else {
        tabPane.data[scoreIndex].data[0].rewards.rewards[index].prize.push(
          {
            id: 0,
            num: 0,
            type: 1,
            rtype: 1,
            is_ts: 0,
            skin: 0,
            ts: 0
          }
        )
      }

      this.saveTabPane(levelName, tabPane)
    },
    delReward(levelName, groupName, index, i) {
      this.formData[levelName][groupName].data[index].reward = this.formData[levelName][groupName].data[index].reward.filter((item, key) => {
        return key !== i
      })
    },
    groupChange(v, levelName, oldGroupName, isParent = false, index, scoreIndex) {
      v = v.sort()
      const newGroupName = v.join('-')
      const tabPane = this.getTabPane(levelName)
      if (isParent) {
        tabPane.children[index].data[scoreIndex].group = v
        tabPane.children[index].data[scoreIndex].group_name = newGroupName
        tabPane.children[index].data[scoreIndex].group_bak = v
      } else {
        tabPane.data[0].group = v
        tabPane.data[0].group_name = newGroupName
        tabPane.data[0].group_bak = v
      }
    },
    removeReward(levelName, index, scoreIndex, i, isParent = false, parentIndex = 0) {
      const tabPane = this.getTabPane(levelName)
      if (!tabPane) {
        this.msgError('奖励添加失败,未找到元素')
        return
      }
      if (isParent) {
        tabPane.children[parentIndex].data[scoreIndex].data[0].rewards.rewards[index].prize = tabPane.children[parentIndex].data[scoreIndex].data[0].rewards.rewards[index].prize.filter((item, key) => {
          return i !== key
        })
      } else {
        tabPane.data[scoreIndex].data[0].rewards.rewards[index].prize = tabPane.data[scoreIndex].data[0].rewards.rewards[index].prize.filter((item, key) => {
          return i !== key
        })

        this.saveTabPane(levelName, tabPane)
      }
    }, getLabelName(label) {
      const arr = label.split('-')
      let typeName = ''
      this.conditionType.forEach((item) => {
        if (item.value === arr[0]) {
          typeName = item.label
        }
      })
      return typeName + '-Lv:' + arr[1] + '-' + arr[2]
    }, mtTypeChange(v, levelName, groupName, index) {
      this.formData[levelName][groupName].data[0].rewards[index].sku = ''
    }, getRewardList(prize, type) {
      return getRewardListForType(prize, this.rewardType, type)
    },
    checkFormData(label) {
      let count = 0
      for (const i in this.formData[label]) {
        const val = this.formData[label][i]
        count += val.data[0].rewards.length
      }
      if (count > 0) {
        return true
      }

      return false
    },
    getGroup() {
      getUserTypeAllList().then(res => {
        if (res.code === 200) {
          res.data.forEach(res => {
            this.groups.push({ label: res.name, value: res.groupId })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTabPane(levelName) {
      let tabPane = []
      for (const i in this.tabPane) {
        const val = this.tabPane[i]
        if (val.label === levelName) {
          tabPane = val
          break
        }
      }
      return tabPane
    },
    saveTabPane(levelName, tabPane) {
      for (const i in this.tabPane) {
        const val = this.tabPane[i]
        if (val.label === levelName) {
          this.tabPane[i] = tabPane
          break
        }
      }
    },
    delChildren(levelName, index) {
      const tabPane = this.getTabPane(levelName)
      this.$confirm('您确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        tabPane.children = tabPane.children.filter((res, key) => {
          return key !== index
        })
      })
    },
    addTs() {
      this.extraData.ts.push({ s: '', e: '' })
    },
    delTs(i) {
      this.extraData.ts = this.extraData.ts.filter((res, index) => {
        return i !== index
      })
    },
    extraSubmit() {
      const form = {}
      form.isShowSpine = this.extraData.isShowSpine
      form.open = this.extraData.open
      form.ts = {}
      form.colorType = this.extraData.colorType
      form.iconType = this.extraData.iconType
      let index = 1
      for (const i in this.extraData.ts) {
        const val = this.extraData.ts[i]
        if (!val.s) {
          this.msgError('开始时间不能为空')
          return
        }
        if (!val.e) {
          this.msgError('结束时间不能为空')
          return
        }
        if (val.s > val.e) {
          this.msgError('开始时间不能大于结束时间')
          return
        }
        form.ts[index] = this.extraData.ts[i]

        index++
      }

      const data = JSON.stringify(form)
      updateActivityExtraData({ name: this.aid, type: this.actType, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getAct()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getAct() {
      getActivityList({ id: this.aid }).then(res => {
        console.log(res)
        if (res.code === 200) {
          const extraData = res.data.list[0].extraData
          const ts = []
          for (const i in extraData.ts) {
            const val = extraData.ts[i]
            ts.push(val)
          }

          this.extraData.isShowSpine = extraData.isShowSpine
          this.extraData.open = extraData.open
          this.extraData.ts = ts
          this.extraData.colorType = extraData.colorType
          this.extraData.iconType = extraData.iconType
        } else {
          this.msgError('活动获取失败')
        }
      })
    },
    delGroup(labelName, scoreIndex, isChildren) {
      const tabPane = this.getTabPane(labelName)
      delete tabPane.children[scoreIndex]
      if (isChildren) {
        console.log('delete', labelName, scoreIndex, tabPane.children[scoreIndex])
      }
    },
    typeChange(v) {
      let typ = ''
      if (v) {
        typ = this.activtyToType[v]
      }
      getActivityAllList({ type: typ }).then(res => {
        if (res.code === 200) {
          this.activtyList = res.data
          console.log('this.activtyList', this.activtyList)
        }
      })
    },
    addRegulate(data, add) {
      if (add) {
        data.regulate.push(JSON.parse(JSON.stringify(this.defaultRegulate)))
      } else {
        data.regulate.pop()
      }
    },
    addHeightBetControl(data, add) {
      if (add) {
        data.push({ bet: 0, ce: 0 })
      } else {
        data.pop()
      }
    }
  }
}
</script>

<style scoped>
</style>
